import { useMemo } from 'react';

import { queryRegionHref } from '../dashboards/primitives/scope/query-region-href';
import {
  flattenRegions,
  useRegionHierarchy,
} from '../dashboards/primitives/scope/region-hierarchy';
import { ScopePicker } from '../dashboards/primitives/scope/ScopePicker';

export interface PrivateEventsScopePickerProps {
  /** The region in the address, or undefined for all regions. */
  regionSlug: string | undefined;
  /** The regions the caller's list is drawn from; null for every region,
   *  undefined while that is not yet known. */
  visibleRegionIds: string[] | null | undefined;
  isPhone: boolean;
}

const privateEventsHref = queryRegionHref('/admin/private-events');

export function PrivateEventsScopePicker({
  regionSlug,
  visibleRegionIds,
  isPhone,
}: PrivateEventsScopePickerProps) {
  const { data } = useRegionHierarchy();

  const regions = useMemo(() => {
    if (!data || visibleRegionIds === undefined) return [];
    const all = flattenRegions(data);
    return visibleRegionIds ? all.filter((r) => visibleRegionIds.includes(r.id)) : all;
  }, [data, visibleRegionIds]);

  const current = regionSlug ? regions.find((r) => r.slug === regionSlug) : undefined;

  return (
    <ScopePicker
      label={regionSlug ? (current?.name ?? regionSlug) : 'All regions'}
      currentRegionId={current?.id ?? null}
      regions={regions}
      hrefFor={privateEventsHref}
      isPhone={isPhone}
    />
  );
}
